var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCellType = function SvgCellType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#cellType_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.905 1.149a11.5 11.5 0 0 0-5.143 0M6.488 2.52a12 12 0 0 0-2.04 1.595 12 12 0 0 0-1.594 2.04M1.482 9.429a11.5 11.5 0 0 0 0 5.143M2.854 17.846a12 12 0 0 0 1.594 2.04c.62.603 1.304 1.138 2.04 1.594M9.762 22.852a11.5 11.5 0 0 0 5.143 0M18.18 21.48a12 12 0 0 0 2.04-1.594 12 12 0 0 0 1.594-2.04M23.185 14.572a11.5 11.5 0 0 0 0-5.143M21.814 6.155c-.457-.736-.991-1.42-1.595-2.04a12 12 0 0 0-2.04-1.594"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cellType_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333 0h24v24h-24z"
  })))));
};
export default SvgCellType;